module.exports = __webpack_public_path__ + "static/media/Product.419efbd5.png";